import { useState } from "react";
import { Link } from "react-router-dom";
import { UserPlus, Mail, Lock, User, ArrowRight, Loader } from "lucide-react";
import { motion } from "framer-motion";
import { useUserStore } from "../stores/useUserStore";

const SignUpPage = () => {
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		email: "",
		password: "",
		confirmPassword: "",
	});

	const { signup, loading } = useUserStore();

	const handleSubmit = (e) => {
		e.preventDefault();
		signup(formData);
	};

	return (
		<div className='flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-white'>
			<motion.div
				className='sm:mx-auto sm:w-full sm:max-w-md'
				initial={{ opacity: 0, y: -20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
			>
				<h2 className='mt-6 text-center text-3xl font-extrabold text-brand-primary'>צור חשבון חדש</h2>
			</motion.div>

			<motion.div
				className='mt-8 sm:mx-auto sm:w-full sm:max-w-md'
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, delay: 0.2 }}
			>
				<div className='bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 border border-gray-200'>
					<form onSubmit={handleSubmit} className='space-y-6'>
						<div>
							<label htmlFor='firstName' className='block text-sm font-medium text-gray-700'>
								שם פרטי
							</label>
							<div className='mt-1 relative rounded-md shadow-sm'>
								<div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
									<User className='h-5 w-5 text-gray-600' aria-hidden='true' />
								</div>
								<input
									id='firstName'
									name='firstName'
									type='text'
									required
									value={formData.firstName}
									onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
									className='block w-full px-3 py-2 pl-10 bg-white text-gray-900 border border-gray-300 rounded-md shadow-sm
									 placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm'
									placeholder='John'
									autoComplete='given-name'
								/>
							</div>
						</div>

						<div>
							<label htmlFor='lastName' className='block text-sm font-medium text-gray-700'>
								שם משפחה
							</label>
							<div className='mt-1 relative rounded-md shadow-sm'>
								<div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
									<User className='h-5 w-5 text-gray-600' aria-hidden='true' />
								</div>
								<input
									id='lastName'
									name='lastName'
									type='text'
									required
									value={formData.lastName}
									onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
									className='block w-full px-3 py-2 pl-10 bg-white text-gray-900 border border-gray-300 rounded-md shadow-sm
									 placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm'
									placeholder='Doe'
									autoComplete='family-name'
								/>
							</div>
						</div>

						<div>
							<label htmlFor='email' className='block text-sm font-medium text-gray-700'>
								כתובת אימייל
							</label>
							<div className='mt-1 relative rounded-md shadow-sm'>
								<div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
									<Mail className='h-5 w-5 text-gray-600' aria-hidden='true' />
								</div>
								<input
									id='email'
									name='email'
									type='email'
									required
									value={formData.email}
									onChange={(e) => setFormData({ ...formData, email: e.target.value })}
									className=' block w-full px-3 py-2 pl-10 bg-white text-gray-900 border border-gray-300 
									rounded-md shadow-sm
									 placeholder-gray-400 focus:outline-none focus:ring-brand-primary 
									 focus:border-brand-primary sm:text-sm'
									placeholder='you@example.com'
									autoComplete='email'
								/>
							</div>
						</div>

						<div>
							<label htmlFor='password' className='block text-sm font-medium text-gray-700'>
								סיסמה
							</label>
							<div className='mt-1 relative rounded-md shadow-sm'>
								<div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
									<Lock className='h-5 w-5 text-gray-600' aria-hidden='true' />
								</div>
								<input
									id='password'
									name='password'
									type='password'
									required
									value={formData.password}
									onChange={(e) => setFormData({ ...formData, password: e.target.value })}
									className=' block w-full px-3 py-2 pl-10 bg-white text-gray-900 border border-gray-300 
									rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm'
									placeholder='••••••••'
									autoComplete='new-password'
								/>
							</div>
						</div>

						<div>
							<label htmlFor='confirmPassword' className='block text-sm font-medium text-gray-700'>
								אימות סיסמה
							</label>
							<div className='mt-1 relative rounded-md shadow-sm'>
								<div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
									<Lock className='h-5 w-5 text-gray-600' aria-hidden='true' />
								</div>
								<input
									id='confirmPassword'
									name='confirmPassword'
									type='password'
									required
									value={formData.confirmPassword}
									onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
									className=' block w-full px-3 py-2 pl-10 bg-white text-gray-900 border
									 border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm'
									placeholder='••••••••'
									autoComplete='new-password'
								/>
							</div>
						</div>

						<button
							type='submit'
							className='w-full flex justify-center py-2 px-4 border border-transparent 
							rounded-md shadow-sm text-sm font-medium text-white bg-brand-primary
							 hover:bg-brand-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2
							  focus:ring-brand-primary transition duration-150 ease-in-out disabled:opacity-50'
							disabled={loading}
						>
							{loading ? (
								<>
									<Loader className='mr-2 h-5 w-5 animate-spin' aria-hidden='true' />
									Loading...
								</>
							) : (
								<>
									<UserPlus className='mr-2 h-5 w-5' aria-hidden='true' />
									הרשמה
								</>
							)}
						</button>
					</form>

					<p className='mt-8 text-center text-sm text-gray-600'>
						כבר יש לך חשבון?{" "}
						<Link to='/login' className='font-medium text-brand-primary text-brand-primary-hover'>
							התחבר כאן <ArrowRight className='inline h-4 w-4' />
						</Link>
					</p>
				</div>
			</motion.div>
		</div>
	);
};
export default SignUpPage;
